import styled, { css } from 'styled-components';

import { device, typography } from '@/styles/helpers';

export const ScProgressBar = styled.div<{ progress: string }>`
  padding: 8px 0;
  max-width: 800px;
  width: 100%;

  & > .progress-line {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    height: 32px;
    border-radius: 360px;
    background: ${({ theme }) => theme.whiteColor};

    &::after {
      content: '';
      position: absolute;
      inset: 2px;
      border-radius: 360px 0 0 360px;
      background: linear-gradient(90deg, #ffad01 19.02%, #ffd500 100%);
      width: ${({ progress }) => progress};
    }

    .breakpoint {
      z-index: 1;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  @media (${device.mobile}) {
    padding: 4px 0;
    max-width: auto;
  }
`;

interface ScCoin {
  mode: 'passed' | 'future';
}

export const ScCoin = styled.div<ScCoin>`
  display: flex;
  width: 48px;
  height: 48px;
  justify-content: center;
  align-items: center;
  border-radius: 360px;

  ${({ mode }) =>
    mode === 'passed'
      ? css`
          border: 2px solid #ffd500;
          background: linear-gradient(
            180deg,
            #ffd500 0%,
            #ffad01 51.13%,
            #bd5d0d 105.56%
          );
          box-shadow:
            0px 0px 12px 0px #bd5d0d inset,
            0px 0px 1px 0px rgba(91, 51, 5, 0.7),
            0px 0px 5px 0px rgba(91, 51, 5, 0.7);
        `
      : css`
          border: 2px solid rgba(0, 0, 0, 0.05);
          background: ${({ theme }) => theme.whiteColor};
          box-shadow:
            -2px 0px 10px 0px rgba(0, 0, 0, 0.2),
            -2px 0px 20px 0px rgba(0, 0, 0, 0.2);
        `}

  p {
    color: ${({ theme }) => theme.blackColor};
    ${typography['body1bold']}
    z-index: 2;

    span {
      ${typography['caption2bold']}
    }
  }

  @media (${device.mobile}) {
    width: 40px;
    height: 40px;

    p {
      ${typography['body2bold']}

      span {
        ${typography['caption1bold']}
      }
    }
  }
`;

export const ScProgressBarContainer = styled.div`
  width: 100%;
  z-index: 4;

  .deadline-starts {
    margin: 8px 0;
    line-height: 18px;
    text-transform: capitalize;
  }
  .deadline-finishes {
    text-align: end;
    line-height: 18px;
    margin-top: 8px;
    text-transform: capitalize;
  }

  .deadline-ends {
    margin-right: 4px;
    text-transform: capitalize;
  }
`;
